<template>
  <div class="ushk-news-switch">
    <div class="ushk-news-switch__h">{{ text }}</div>
    <div class="ushk-news-switch__b">
      <jin-switch on-text="" off-text="" v-model="isOpen" :width="36" :class="{'is-open': isOpen}"></jin-switch>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  export default {
    name: '',
    components: {},
    computed: {
      ...mapGetters([])
    },
    props: {
      text: String,
      type: String,
      value: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value (v) {
        this.isOpen = v
      },
      isOpen (v) {
        this.$emit('input', v)
      }
    },
    data() {
      return {
        isOpen: this.value
      }
    }
  }

</script>



// WEBPACK FOOTER //
// Switch.vue?7f32654e